var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-box"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.htmlData)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }